const OPACITY = Math.floor(255) << 24;

let initialized = false;
let stream = null;
let canvas = null;
let ctx = null;
let imageData = null;
let buffer32 = null;
let isPaused = false;
let desiredFrameDuration = 16;

const init = (width = 640, height = 480, fps) => {
  canvas = Object.assign(document.createElement('canvas'), { width, height });
  ctx = canvas.getContext('2d', { alpha: true });
  imageData = ctx.createImageData(canvas.width, canvas.height); // create image data
  buffer32 = new Uint32Array(imageData.data.buffer); // get 32-bit view
  initialized = true;
  if (fps) {
    desiredFrameDuration = Math.ceil(1000 / fps);
  }
};

/**
 * Stop and destroy the white noise canvas and stream.
 */
export const dispose = () => {
  isPaused = true;
  if (stream) {
    stream.getVideoTracks()[0].stop();
    stream = null;
  }
  canvas = null;
  ctx = null;
  initialized = false;
};

/**
 * Pause the white noise generation.
 */
export const pause = () => {
  isPaused = true;
};

/**
 * Start or resume the white noise generation.
 */
export const start = () => {
  isPaused = false;
  draw();
};

function draw() {
  if (isPaused) {
    return;
  }
  // skip every other frame to produces 30fps instead of 60 and be gentler on the CPU
  getWhiteNoiseFrame();
  setTimeout(draw, desiredFrameDuration);
}

/**
 * Initialize and start the white noise canvas. This uses a singleton pattern: no more than one white noise is generated at a time.
 * @param {number} [width] - The width of the generated frames, in pixels.
 * @param {number} [height] - The width of the generated frames, in pixels.
 * @param {number} [fps] - The number of generated frames per second.
 * @returns {MediaStream} The generated white noise stream
 */
export const getWhiteNoiseStream = (width, height, fps) => {
  if (stream) {
    return stream;
  }
  if (!initialized) {
    init(width, height, fps);
  }

  start();
  stream = canvas.captureStream();
  return stream;
};

const getWhiteNoiseFrame = () => {
  for (let i = 0; i < buffer32.length; ++i) {
    buffer32[i] = Math.floor(Math.random() * 0xffffff) | OPACITY; // set all of RGBA for pixel in one go
  }
  ctx.putImageData(imageData, 0, 0);
};
